import React from 'react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import { Curso, TodosLosCursos } from '../componentes';
import { CursoDTO } from '../tipos';
import CrearNuevoCurso from './CrearNuevoCurso';

type Props = Readonly<{ oculto?: boolean }>;

interface State {
    readonly cargando: boolean;
    readonly cursos: ReadonlyArray<CursoDTO>;
}

class Administrar extends React.Component<{ oculto?: boolean }, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        cargando: true,
        cursos: [],
    };

    public componentDidMount() {
        if (!this.props.oculto) {
            this.obtenerCursos().catch(); // La función maneja sus errores
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.oculto && !this.props.oculto) {
            this.obtenerCursos().catch(); // La función maneja sus errores
        }
    }

    public render() {
        const { oculto } = this.props;
        const { cargando, cursos } = this.state;

        return (
            <>
                {!oculto && (
                    <CrearNuevoCurso
                        cargando={cargando}
                        cursos={cursos}
                        creandoNuevoCurso={() => {
                            this.setState({ cargando: true });
                        }}
                        creacionTerminada={async () => this.obtenerCursos()}
                    />
                )}

                <TodosLosCursos
                    cargando={cargando}
                    oculto={oculto}
                    cursos={cursos}
                    renderizarCurso={curso => (
                        <Curso
                            key={curso.id}
                            {...curso}
                            color={curso.colorDeSugerencia}
                            opacarLleno
                            profesor={curso.profesor && curso.profesor.nombre}
                            asistentes={curso.asistentes.map(asis => asis.nombre)}
                        />
                    )}
                />
            </>
        );
    }

    private readonly obtenerCursos = async () => {
        this.setState({ cargando: true });

        return clienteApi
            .ejecutar('listaDeCursos')
            .then(({ cursos }) => {
                this.setState({
                    cargando: false,
                    cursos,
                });
            })
            .catch(error => {
                this.setState({ cargando: false });
                this.context.mostrarModalError(error);
            });
    };
}

export default Administrar;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/Administrar/index.tsx